"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SchemaError_1 = require("../../Components/Http/Error/SchemaError");
const HttpClient_1 = require("../../Components/Http/HttpClient");
class HttpEntityClient {
    constructor(httpClient = new HttpClient_1.default()) {
        this.httpClient = httpClient;
    }
    async get(url, schema, query, headers) {
        return this.checkResponse(await this.httpClient.get(url, query, headers), schema);
    }
    async post(url, body, schema, headers) {
        return this.checkResponse(await this.httpClient.post(url, body, headers), schema);
    }
    async checkResponse(response, schema) {
        const result = schema.safeParse(await response.json());
        if (result.success === false) {
            throw new SchemaError_1.default(response, schema);
        }
        return result.data;
    }
}
exports.default = HttpEntityClient;
//# sourceMappingURL=HttpEntityClient.js.map